import React from 'react';
import { Link } from 'react-router-dom';

import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';

const styles = {
  breadcrumbs: {
    padding: '0.2rem 0.5rem',
    background: '#f8f8f8',
    borderBottom: '1px solid #d8d8d8',
    marginBottom: '.5rem'
  },
  breadcrumbs__item: {
    color: '#00ae8e',
    textDecoration: 'none',
    textTransform: 'uppercase',
    fontSize: '0.875rem',
    paddingTop: '0.2rem',
    paddingBottom: '0.2rem',
    display: 'inline-block',
    '&:not(:first-child):before': {
      content: "' / '",
      display: 'inline-block',
      paddingLeft: '0.7rem',
      paddingRight: '0.7rem'
    }
  },
  breadcrumbs__text: {
    color: '#0a0a0a'
  }
};

const SiteHeaderBreadCrumbNav = ({ show, links, classes }) => {
  if (!show) {
    return null;
  }

  let list = [];

  if (links.site) {
    list.push(
      <Link
        key="breadcrumb__site"
        className={classes.breadcrumbs__item}
        to={`/sites/${links.site.id}`}
      >
        SITE:&nbsp;{links.site.name}
      </Link>
    );
  }

  if (links.site && !links.logger && links.match.path.endsWith('/sankey')) {
    list.push(
      <span
        key="breadcrumb__site__sankey"
        className={classNames(
          classes.breadcrumbs__item,
          classes.breadcrumbs__text
        )}
      >
        ENERGYFLOW
      </span>
    );
  }

  if (links.logger) {
    list.push(
      <span
        key="breadcrumb__logger"
        className={classNames(
          classes.breadcrumbs__item,
          classes.breadcrumbs__text
        )}
      >
        LOGGER:&nbsp;{links.logger.description}
      </span>
    );
  }

  return (
    <nav className={classes.breadcrumbs}>
      <Link className={classes.breadcrumbs__item} to="/">
        Home
      </Link>
      {list}
    </nav>
  );
};

export default withStyles(styles, { name: 'SiteHeaderBreadCrumbNav' })(
  SiteHeaderBreadCrumbNav
);



// WEBPACK FOOTER //
// ./src/components/SiteHeaderBreadCrumbNav.js